<template>
  <div>
    <div class="fix-wrapper">
      <breadcrumb
        :crumbs="[
          $t('menu.inventories'),
          $t('action.check') + '：' + warehouseName,
        ]"
      ></breadcrumb>
      <div class="container">
        <el-form ref="formObjForm" :model="formObj" size="small">
          <div class="pd20">
            <fieldset class="mgb15">
              <legend>{{ $t("text.baseInfo") }}</legend>
              <div
                v-for="(item, index) in formObj.items"
                :key="index"
                :class="
                  index == formObj.items.length - 1 ? '' : 'border-bottom mgb10'
                "
              >
                <el-row :gutter="10">
                  <el-col :span="19">
                    <el-row :gutter="10">
                      <el-col :span="6">
                        <el-form-item>
                          <el-select
                            size="small"
                            v-model="item.serialNo"
                            filterable
                            remote
                            :remote-method="querySearchSerialNo"
                            :loading="serialNosLoading"
                            :clearable="true"
                            :placeholder="
                              $t('rules.mustFill', [
                                $t('material.serialNoName'),
                              ])
                            "
                            @change="handleSelectSerialNo(index)"
                          >
                            <el-option
                              v-for="material in materials"
                              :key="material.serialNo"
                              :label="material.serialNoName"
                              :value="material.serialNo"
                              :style="
                                material.suppliersNoStr == ''
                                  ? ''
                                  : 'height: 55px !important'
                              "
                            >
                              <div>
                                <div>
                                  {{ material.serialNoName }}
                                  <span
                                    v-if="material.parentMaterialId != null"
                                    class="font8 orange"
                                  >
                                    (子物料)
                                  </span>
                                </div>
                                <div class="suppliersNoStr">
                                  <span>{{ material.suppliersNoStr }}</span
                                  ><span class="orange">{{
                                    material.color
                                  }}</span>
                                </div>
                              </div>
                            </el-option>
                          </el-select>
                          <span v-if="item._localRepeatFg" class="red font10">
                            {{
                              $t("rules.filledIn", [$t("material.serialNo")])
                            }}
                          </span>
                        </el-form-item>
                      </el-col>
                      <el-col :span="6">
                        <el-form-item>
                          <el-input
                            size="small"
                            v-model.trim="item._subjectName"
                            :placeholder="$t('material.subject')"
                            :disabled="item.serialNo == null ? false : true"
                          />
                        </el-form-item>
                      </el-col>
                      <el-col :span="6">
                        <el-form-item>
                          <el-input
                            size="small"
                            v-model.trim="item._color"
                            :placeholder="$t('material.color')"
                            :disabled="item.serialNo == null ? false : true"
                          />
                        </el-form-item>
                      </el-col>
                      <el-col :span="6">
                        <el-form-item>
                          <el-input
                            size="small"
                            v-if="item.serialNo == null"
                            v-model.trim="item.shelf"
                            :placeholder="$t('inventory.storeQuantity')"
                            :disabled="item.serialNo == null ? false : true"
                          />
                          <span v-if="item.serialNo != null">
                            <el-input
                              size="small"
                              v-if="item._invQuantity != null"
                              v-model.trim="item._invQuantity"
                              :placeholder="
                                $t('rules.mustFill', [$t('menu.shelfs')])
                              "
                              disabled
                            />
                            <div
                              v-if="item._invQuantity == null"
                              class="div-input font10"
                              style="color: #eb9e05"
                            >
                              库存中不存在
                            </div>
                          </span>
                        </el-form-item>
                      </el-col>
                    </el-row>
                    <el-row :gutter="10">
                      <el-col :span="6">
                        <el-form-item>
                          <el-input
                            size="small"
                            v-if="item.serialNo == null"
                            v-model.trim="item.shelf"
                            :placeholder="
                              $t('rules.mustFill', [$t('menu.shelfs')])
                            "
                            :disabled="item.serialNo == null ? false : true"
                          />
                          <span v-if="item.serialNo != null">
                            <el-input
                              size="small"
                              v-if="item._shelf != null"
                              v-model.trim="item.shelf"
                              :placeholder="
                                $t('rules.mustFill', [$t('menu.shelfs')])
                              "
                              disabled
                            />
                            <el-autocomplete
                              size="small"
                              v-if="item._shelf == null"
                              v-model.trim="item.shelf"
                              :fetch-suggestions="querySearchShelfs"
                              style="width: 100%"
                              :placeholder="
                                $t('rules.mustFill', [$t('menu.shelfs')])
                              "
                              @select="handleSelectShelfs(index)"
                            />
                          </span>
                        </el-form-item>
                      </el-col>
                      <el-col :span="6">
                        <el-form-item>
                          <el-input
                            size="small"
                            v-model.trim="item.storeQuantity"
                            :placeholder="
                              $t('rules.mustFill', [
                                $t('inventory.actualQuantity'),
                              ])
                            "
                          />
                        </el-form-item>
                      </el-col>
                      <el-col :span="6">
                        <el-form-item>
                          <el-input
                            size="small"
                            v-model.trim="item.alertQuantity"
                            :placeholder="
                              $t('rules.mustFill', [
                                $t('inventory.alertQuantity'),
                              ])
                            "
                          />
                        </el-form-item>
                      </el-col>
                    </el-row>
                  </el-col>
                  <el-col :span="4">
                    <el-input
                      type="textarea"
                      :rows="3"
                      :placeholder="$t('text.remark')"
                      v-model="item.remark"
                    ></el-input>
                  </el-col>

                  <el-col v-if="index" :span="1">
                    <el-form-item>
                      <i class="el-icon-delete red" @click="remove(index)" />
                    </el-form-item>
                  </el-col>
                </el-row>
              </div>
              <div class="center">
                <el-button
                  v-if="formObj.items.length < 10"
                  type="info"
                  @click="addMore"
                  plain
                  round
                >
                  {{ $t("action.addMaterial") }}
                </el-button>
                <span v-else class="orange">
                  {{ $t("prompt.addMorePrompt") }}
                </span>
              </div>
            </fieldset>
          </div>
          <div class="form-footer">
            <el-button
              type="primary"
              size="medium"
              plain
              :loading="saveDoing"
              @click="saveSubmit"
              >{{ $t("text.submit") }}</el-button
            >
            <back-button />
          </div>
        </el-form>
      </div>
    </div>
  </div>
</template>
<script>
import Vue from "vue";
import { page } from "@/utils/mixins.js";
import Util from "@/utils/index.js";
import BackButton from "@/components/BackButton";
import Warehouse from "@/api/warehouse.js";
import Material from "@/api/material.js";
import InventoryMms from "@/api/inventoryMms.js";

function bulid() {
  return {
    serialNo: null,
    storeQuantity: null,
    shelf: null,
    alertQuantity: null,
    warehouseId: null,
    remark: null,
    _localRepeatFg: false,
    _subjectName: null,
    _color: null,
    _unit: null,
    _invQuantity: null,
    _shelf: null,
  };
}
export default {
  mixins: [page],
  components: { BackButton },
  data() {
    return {
      Util: Util,
      warehouses: [],
      warehouseId: null,
      warehouseName: null,
      formObj: {
        items: [bulid(), bulid(), bulid()],
      },
      materials: [],
      serialNosLoading: false,
      saveDoing: false,
    };
  },

  computed: {},
  created() {
    const self = this;
    self.warehouseId = self.$route.params.warehouseId;
    Warehouse.findByTenantId().then(function (res) {
      if (res.status === 200) {
        self.warehouse = res.data;
        self.warehouseName = self.warehouse.find(
          (s) => s.id === Number(self.warehouseId)
        ).name;
      } else {
        self.sysError();
      }
    });
  },
  methods: {
    querySearchSerialNo(queryString, cb) {
      const self = this;
      if (queryString == null || queryString.length < 1) {
        return;
      }
      this.serialNosLoading = true;
      Material.vagueFindBySerialNoOrName({ serialNo: queryString }).then(
        function (res) {
          self.materials = res.data;
          if (self.materials.length !== 0) {
            for (const material of self.materials) {
              Vue.set(
                material,
                "serialNoName",
                material.serialNo + "(" + material.name + ")"
              );
            }
          }
          self.serialNosLoading = false;
        }
      );
    },
    handleSelectSerialNo(idx) {
      const self = this;
      self.formObj.items[idx]._localRepeatFg = false;
      self.formObj.items[idx]._invQuantity = null;
      self.formObj.items[idx].shelf = null;
      const item = self.materials.find(
        (p) => p.serialNo === self.formObj.items[idx].serialNo
      );
      if (item.parentMaterialId != null) {
        this.$message({
          message:
            "该物料是子物料，请使用主物料【" +
            item.parentMaterialSerialNo +
            "】盘点",
          type: "warning",
        });
        self.formObj.items[idx].serialNo = null;
        return;
      }
      self.formObj.items[idx]._subjectName = item.subjectName;
      self.formObj.items[idx]._color = item.color + "(" + item.colorNo + ")";
      self.formObj.items[idx]._unit = item.unit;
      InventoryMms.findBySerialNoWithWarehouse({
        serialNo: self.formObj.items[idx].serialNo,
        warehouseId: self.warehouseId,
      }).then(function (res) {
        if (res.data.code == 200) {
          const invMaterial = res.data.entity;
          self.formObj.items[idx]._invQuantity =
            invMaterial.storeQuantity + invMaterial.material.unit;
          self.formObj.items[idx]._shelf = invMaterial.shelf;
          self.formObj.items[idx].shelf = invMaterial.shelf;
          self.formObj.items[idx].alertQuantity =
            invMaterial.alertQuantity || 0;
          self.formObj.items[idx].remark = invMaterial.remark;
        } else {
          self.formObj.items[idx]._invQuantity = null;
          self.formObj.items[idx]._shelf = null;
          self.formObj.items[idx].remark = null;
        }
      });
      // 前台本地过滤
      const iis = self.formObj.items.filter(function (ii) {
        return ii.serialNo === self.formObj.items[idx].serialNo;
      });
      if (iis.length > 1) {
        self.formObj.items[idx]._localRepeatFg = true;
        return;
      }
    },
    // 库位
    querySearchShelfs(queryString, cb) {
      const self = this;
      InventoryMms.getShelfs({ warehouseId: self.warehouseId }).then(function (
        res
      ) {
        const shelfs = res.data.map((item) => {
          return { value: item };
        });
        cb(shelfs);
      });
    },
    handleSelectShelfs(index) {
      this.formObj.items[index].shelf = this.formObj.items[index].shelf;
    },

    addMore() {
      this.formObj.items.push(bulid());
    },
    remove(index) {
      this.formObj.items.splice(index, 1);
    },
    saveSubmit() {
      const self = this;
      const items = JSON.parse(JSON.stringify(this.formObj.items)).filter(
        function (item) {
          return (
            item.serialNo != null &&
            item.serialNo != "" &&
            item.shelf != null &&
            item.shelf != "" &&
            item.storeQuantity != null &&
            item.storeQuantity != "" &&
            item.alertQuantity != null &&
            item.alertQuantity != ""
          );
        }
      );

      if (items.length === 0) {
        this.$message({
          message: self.$t("prompt.atLeastOneDataFill"),
          type: "warning",
        });
        return;
      }
      for (const item of items) {
        if (item._localRepeatFg === true) {
          self.$message({
            message: self.$t("prompt.errorMessage"),
            type: "warning",
          });
          return;
        }

        if (!Util.regexQuantity(item.storeQuantity)) {
          self.$message({
            message: self.$t("rules.regex", [
              self.$t("inventory.storeQuantity"),
            ]),
            type: "warning",
          });
          return;
        }
        if (!Util.regexQuantity(item.alertQuantity)) {
          self.$message({
            message: self.$t("rules.regex", [
              self.$t("inventory.alertQuantity"),
            ]),
            type: "warning",
          });
          return;
        }
        item.warehouseId = self.warehouseId;
      }
      // console.log("=====", data);
      self.$refs.formObjForm.validate((valid) => {
        if (valid) {
          self.saveDoing = true;
          InventoryMms.batchCheck(items).then(function (res) {
            if (res.status === 200) {
              self.saveDoing = false;
              self.$message({
                message: self.$t("prompt.checkSuccess"),
                type: "success",
              });
              self.$router.push({ name: "mmsInventories" });
            } else {
              self.sysError();
            }
          });
        } else {
          return false;
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
</style>